import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultUserInfo } from '../interfaces/User'
import { useAuth } from './useAuth'

interface C102UserUpdateProps {
  execUserUpdate: (
    loginId: string,
    email?: string,
    authenticated?: boolean,
    token?: string,
  ) => Promise<ResultUserInfo>
  loading: loadStatus
}
// C102 ユーザー更新API呼出
export const useC102UserUpdate = (): C102UserUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execUserUpdate = async (
    loginId: string,
    email?: string,
    authenticated?: boolean,
    token?: string,
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = token ? token : await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // ボディ作成
      const body = {} as { email?: string; authenticated?: boolean }
      if (email) {
        body.email = email
      }
      if (authenticated !== undefined) {
        body.authenticated = authenticated
      }
      // console.log(body);

      const response = await axios.put(`${baseUrl}${stage}${apiUrl.usersPath}${loginId}`, body, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execUserUpdate, loading }
}
